// SerialPickModal — khi gõ 6 số IMEI cuối trúng NHIỀU máy còn tồn, hiện danh
// sách (tên SP + IMEI đầy đủ + kho) cho nhân viên tự bấm chọn (yêu cầu 27/07).
// Máy ở kho khác vẫn hiện nhưng bị khóa, kèm lý do — để nhân viên biết máy đó
// tồn tại chứ không phải "không tìm thấy".
import { X } from "lucide-react";
import type { ScanSerialCandidate } from "./use-scan-resolve";

interface Props {
  candidates: ScanSerialCandidate[];
  /** Chuỗi đã gõ — hiện lại trên tiêu đề cho dễ đối chiếu. */
  query?: string;
  onPick: (c: ScanSerialCandidate) => void;
  onClose: () => void;
}

export function SerialPickModal({ candidates, query, onPick, onClose }: Props) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={onClose}>
      <div
        className="w-full max-w-lg rounded-xl border bg-card p-4 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-3 flex items-center justify-between">
          <div>
            <h2 className="font-semibold">Nhiều máy trùng số{query ? ` "${query}"` : ""}</h2>
            <p className="text-xs text-muted-foreground">Bấm chọn đúng máy cần bán/chuyển:</p>
          </div>
          <button type="button" onClick={onClose} className="text-muted-foreground hover:text-foreground">
            <X size={18} />
          </button>
        </div>

        <div className="max-h-80 space-y-2 overflow-y-auto">
          {candidates.map((c) => (
            <button
              key={c.serial.id}
              type="button"
              disabled={!c.ok}
              onClick={() => onPick(c)}
              className={[
                "w-full rounded-lg border p-3 text-left transition-colors",
                c.ok
                  ? "hover:border-primary hover:bg-primary/5 cursor-pointer"
                  : "opacity-60 cursor-not-allowed bg-muted/30",
              ].join(" ")}
            >
              <p className="text-sm font-medium">{c.variant.productName}</p>
              <p className="font-mono text-xs text-muted-foreground">{c.variant.sku}</p>
              <p className="mt-1 font-mono text-sm font-semibold text-primary break-all">
                {c.serial.serialNo}
              </p>
              <p className={`text-xs ${c.ok ? "text-green-600" : "text-destructive"}`}>
                {c.ok
                  ? `✓ Còn tồn${c.serial.warehouseName ? ` — ${c.serial.warehouseName}` : ""}`
                  : c.reason ?? "Không chọn được"}
              </p>
            </button>
          ))}
        </div>

        <p className="mt-3 text-xs text-muted-foreground">
          Không thấy máy cần tìm? Gõ IMEI đầy đủ để tra chính xác.
        </p>
      </div>
    </div>
  );
}
